import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import { generateMetaHead } from '~/utils/head';
export default {
  // headerFixed: false,
  // middleware: ['password-protect'],
  components: {
    LoadingOverlay
  },
  data() {
    return {
      loaded: false,
      sliderValue: 5000
    };
  },
  head() {
    return generateMetaHead({
      title: 'Get In Touch | Extra',
      description: 'Extra members deserve the best standard of service! Contact our Member Concierge via the Extra app for one on one help with anything you need.'
    });
  }
};